<template>
  <div>
    <div>
      <div>
        <!-- /End replace -->
      </div>
      <div class="container">
        <div
          class="row justify-content-center mt-3"
          style="text-align: center;"
        >
          <div class="col-md-12 mt-4">
            <h3>LINE Remove</h3>
          </div>
          <div class="col-md-12 mt-4">
            <b-input type="text" v-model="email" placeholder="Email"></b-input>
            <b-button
              variant="danger"
              @click.prevent="removeLine"
              class="gobutton"
              >Remove</b-button
            >
          </div>
          <b-alert
            v-model="showAlert"
            dismissible
            :variant="alertVariant"
            class="mt-3"
          >
            {{ alertMessage }}
          </b-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      name: "",
      email: "",
      showAlert: false,
      alertVariant: "danger",
      alertMessage: "",
    };
  },
  mounted() {
    this.lineId = this.$route.params.id;
  },
  created() {},
  computed: {
    ...mapState({
      user: "user",
    }),
    getCurrentMemberCount() {
      return this.currentMemberCount;
    },
  },
  methods: {
    removeLine() {
      axios
        .post("/api/members/lineremove", { email: this.email })
        .then((response) => {
          if (response.data.status == "SUCCESS") {
            //console.log(response.data.message);
            this.showAlert = true;
            this.alertVariant = "success";
            this.alertMessage = "LINE Remove Success";
          } else {
            this.showAlert = true;
            this.alertVariant = "danger";
            this.alertMessage = response.data.message;
          }
        });
    },
    logout() {
      axios.post("/logout").then((response) => {
        localStorage.removeItem("isLoggedIn");
        this.$router.push({ name: "Home" });
      });
    },
  },
};
</script>
